export default __webpack_public_path__ + "static/media/ies_AcuityBrands.e3d20418.png";